// Bootstrap de la aplicación. Angular 21 standalone: no hay NgModule raíz, se
// arranca el componente `App` con la config de providers de `app.config.ts`
// (router, interceptors, HttpClient). Es el único punto de entrada del bundle.
//
// El `.catch` es la última red: un error aquí ocurre antes de que exista la app,
// así que no hay ErrorHandler de Angular todavía y solo queda la consola.
import { bootstrapApplication } from '@angular/platform-browser';

import { appConfig } from './app/app.config';
import { App } from './app/app';

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
